"use client";

import { useDict } from "@/components/i18n/DictProvider";
import { Sparkles } from "lucide-react";
import { RichHtml } from "@/components/ui/RichHtml";

/**
 * Sidebar companion to CourseStartCard. Renders the course's
 * `courseFeatures` content ("What is included") as a small card slotted
 * below the enrol CTA. Keeping it out of the main left column lets the
 * sticky enrol card and this list sit together while users browse the
 * long-form sections to the left.
 */
export function CourseIncludedCard({ html }: { html: string | null | undefined }) {
  const t = useDict();
  if (!html) return null;
  return (
    <section
      className="course-included rounded-card border border-border/60 bg-card p-6"
      aria-labelledby="course-included-title"
    >
      <header className="flex items-center gap-3 mb-4">
        <span className="grid place-items-center size-9 rounded-xl bg-accent/[0.08] text-accent">
          <Sparkles className="size-4" aria-hidden />
        </span>
        <h2
          id="course-included-title"
          className="!text-[17px] !font-semibold !leading-tight !text-foreground !mb-0"
        >
          {t.detail.whatIsIncluded}
        </h2>
      </header>
      <RichHtml html={html} className="!text-[14px] !leading-relaxed" />
    </section>
  );
}
